import { QueryKeys } from '@openx/utils/api/queryKeys';
import { firstLetterUppercase } from '@openx/utils/lib/firstLetterUppercase';
import { useQuery } from '@tanstack/react-query';
import { GetDistinctAudienceStatusesDocument } from '../../../../graphql/query/audiences/GetDistinctAudienceStatuses.generated';
import { getGraphQLRequestFromClient } from '../../../graphql/types';

export const useAudienceStatuses = () => {
  const { data, isLoading: loadingAudienceStatuses } = useQuery({
    queryFn: ({ client }) => getGraphQLRequestFromClient(client)(GetDistinctAudienceStatusesDocument),
    queryKey: [QueryKeys.AUDIENCE, 'statuses'],
  });
  const audienceStatuses = data?.audience_statuses ?? [];

  const options = ['expiring_soon', ...audienceStatuses.map(item => item.status)].map(statusValue => ({
    id: statusValue,
    name: statusValue
      .split('_')
      .map(word => firstLetterUppercase(word))
      .join(' '),
  }));

  return { options, loadingAudienceStatuses };
};
